module.exports = {
	dps: {
		base: '/data/',
		ext: ''
	}
}



// WEBPACK FOOTER //
// ./src/var.js